import { Modal } from "components/Modal";
import { flexColumnCenter } from "style/mixin";
import styled from "styled-components";

export const LimitedOfferModalContainer = styled(Modal)`
  .limited-offer-wrapper {
    ${flexColumnCenter}

    .offer-card {
      ${flexColumnCenter}
      background: ${({ theme }) => theme.global.color.quinary};
      border-radius: 10px;
      padding: 20px 50px 30px 50px;
      width: 406px;
      text-align: center;

      p {
        font-weight: 500;
        font-size: 15px;
        color: ${({ theme }) => theme.global.extraInfo.font.color};
        margin-bottom: 20px;
      }

      .offer-title {
        width: 50%;
        background: ${({ theme }) => theme.heading.color.secondary};
        border-radius: 3px;
        padding: 3px 0px;
        margin-bottom: 10px;

        h2 {
          margin: 0;
          text-align: center;
          font-weight: 700;
          font-size: 20px;
          color: ${({ theme }) => theme.global.color.quinary};
        }
      }

      .discount-wrapper {
        border: 2px dashed #ffffff;
        width: 40%;
        padding: 4px 0px;
        margin-bottom: 20px;

        h3 {
          margin: 0;
          font-weight: bold;
          font-size: 22px;
          color: ${({ theme }) => theme.heading.color.secondary};

          span {
            font-weight: 400;
            font-size: 19px;
          }
        }
      }

      h3 {
        font-weight: 500;
        font-size: 15px;
        color: ${({ theme }) => theme.heading.color.secondary};
      }

      a {
        color: ${({ theme }) => theme.global.extraInfo.font.color};
        font-weight: 500;
        font-size: 13px;
      }
    }

    .contact-us-btn {
      width: 226px;
      border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
      margin: 40px 0px 0px 0px;
      padding: 5px 0px;
    }

    .cancel-sub {
      cursor: pointer;
      font-weight: 500;
      font-size: 12px;
      color: ${({ theme }) => theme.global.extraInfo.font.color};
      margin-top: 20px;
    }
  }
`;
